// Use environment variable for API URL, fallback to relative path for development
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, mergedOptions);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      if (response.status === 401) {
        const authCriticalEndpoints = ['/auth/me', '/auth/verify'];
        if (authCriticalEndpoints.some(ep => endpoint.includes(ep))) {
          console.warn('[API] Auth token invalid');
        }
      }

      const error = new Error(errorData.message || errorData.error || `HTTP ${response.status}: ${response.statusText}`);
      error.response = { status: response.status, statusText: response.statusText, data: errorData };
      throw error;
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    }

    return await response.text();
  } catch (error) {
    if (error.name !== 'TypeError') {
      throw error;
    }

    console.error('[API] Network error:', error);
    throw new Error('Error de conexión con el servidor. Verifica tu conexión a internet.');
  }
};